// How the menu is opened from the trigger element.
export enum ContextMenuTriggerMode {
  Primary = 'primary', // Left click on web. Regular press on mobile.
  Secondary = 'secondary', // Right click on web. Long press on mobile.
}
